import React, { useEffect } from 'react';
// import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CITIZENSHIP } from '../constant';
import { getCitizenshipList } from '../actions';

const selectList = ({ api }) => {
  return _.get(api, `${GET_CITIZENSHIP}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    return {
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'attributes.name'),
      fullInfo: item,
    };
  });
};

const Citizenship = ({ name, onChange, value, readOnly }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [
    { label: 'Philippines', value: 'PHL' },
    ...formatOptions(list),
  ];

  const findValue =
    options.find(item => _.get(item, 'fullInfo.attributes.name') === value) ||
    '';

  useEffect(() => {
    if (!_.isEmpty(value)) {
      dispatch(getCitizenshipList({ q: value }));
    }
    if (_.isEmpty(value)) {
      dispatch(getCitizenshipList());
    }
  }, []);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data.value,
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getCitizenshipList({ q: inputValue }, response => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="- Select -"
      value={findValue}
      onChange={handleChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

Citizenship.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

Citizenship.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default Citizenship;
